import React, { useEffect, useState } from "react";
import Table from "../../Common/Table";
import TableFieldsAvailableAssets from "../../../constants/DriverAssets/TableFieldsAvailableAssets.json";
import Dropdown from "sushiweb/Dropdown";
import MenuItem from "sushiweb/MenuItem/MenuItem";

const AvailableAssetsTable = (props) => {
  const {
    driverId,
    driverAssetsAvailableList,
    transactionStatus,
    assetInfo,
    assets,
    setAssets,
    total,
    setTotal,
    setError,
  } = props;

  const getTotal = () => {
    return total;
  };

  const handleChange = (key, val, item) => {
    let obj = { ...assets };

    //to set total value
    if (key === "quantity") {
      let p = total;
      let diff = assets[item.name]
        ? Math.abs(parseInt(assets[item.name]["quantity"]) - val)
        : val;
      if (assets[item.name] && parseInt(assets[item.name]["quantity"]) > val) {
        p -= item.amount ? diff * item.amount : 0;
      } else {
        p += item.amount ? diff * item.amount : 0;
      }
      setTotal(p);
    }
    //to update asset state
    obj[item.name] = {
      quantity:
        key === "quantity"
          ? val
          : obj[item.name]
          ? obj[item.name]["quantity"]
          : 0,
      amount: item.amount,
      size:
        key === "size"
          ? val
          : obj[item.name]
          ? obj[item.name]["size"]
          : item.size
          ? -1
          : 0,
    };
    setAssets(obj);
    setError({});
  };

  const getFieldValue = (item, key) => {
    switch (key) {
      case "size":
      case "quantity":
        return item[key] ? (
          <Dropdown
            id={`asset-${key}`}
            className={`sushi-dropdown ${
              (transactionStatus === "VERIFIED"
                ? true
                : item.valid
                ? false
                : true) && "disabled"
            }`}
            label={`asset-${key}`}
            shouldChange={false}
            value={assets[item.name] ? assets[item.name][key] : ""}
            data-testid={`asset${item.name}`}
            onSelect={(e) => handleChange(key, e, item)}
          >
            {item[key].map((val, idx) => {
              return (
                <MenuItem
                  value={val}
                  id={item["name"] + val + idx}
                  label={val}
                />
              );
            })}
          </Dropdown>
        ) : (
          ""
        );
      default:
        return item[key];
    }
  };

  const getAdditionalRows = () => {
    return (
      <tr>
        <td colSpan={3}>Total</td>
        <td>{getTotal()}</td>
      </tr>
    );
  };

  useEffect(() => {
    if (transactionStatus === "VERIFIED") {
      setAssets({ ...assetInfo });
      let p = total;
      Object.keys(assetInfo).map((asset) => {
        p += assetInfo[asset]["amount"];
      });
      setTotal(p);
    }
  }, [transactionStatus]);

  return (
    <div className="available-assets-view">
      <Table
        list={driverAssetsAvailableList}
        getFieldValue={getFieldValue}
        fields={TableFieldsAvailableAssets}
        isAdditionalRows={true}
        getAdditionalRows={getAdditionalRows}
      />
    </div>
  );
};
export default AvailableAssetsTable;
